export default {

    install: (app, options) => {
        let data = {};
        const getData = (childexpr) => {
            let ret = null;

            if (childexpr && childexpr !== '') {
                ret = window.translations;
                let childs = childexpr.split('.');
                let i;
                for (i = 0; i < childs.length && ret !== undefined; i++) {
                    ret = ret[childs[i]];
                }
            }

            if (ret) {
                return ret;
            }

            return childexpr;
        }

        app.config.globalProperties.$translate = (key, params) => {
            if (typeof (window.translations) === 'undefined') {
                return key;
            }

            if (Object.keys(window.translations).length === 0) {
                return key;
            }

            let langString = '';

            langString = getData(key);

            if (typeof langString === 'undefined') {
                return key;
            }

            if (params) {
                let matches = [];
                let langStringParams = {};
                const regExp = /((^:)|([\s"]:))(\w+)/gm;
                while (null != (matches = regExp.exec(langString))) {
                    let paramName = matches[4];
                    if (typeof params[paramName] !== 'undefined' && typeof (params) === 'object') {
                        langStringParams[':' + paramName] = params[paramName];
                    } else if (typeof (params) === 'string') {
                        langStringParams[':' + paramName] = params;
                    }
                }

                if (langStringParams) {
                    let locale = null;

                    if (typeof document !== 'undefined'
                        && document.documentElement
                        && document.documentElement.lang) {
                        locale = document.documentElement.lang;
                    }

                    if (locale) {
                        locale = locale.toString().split('-')[0];
                    }

                    const shouldPrefixUrls = locale && locale !== 'en';

                    if (shouldPrefixUrls) {
                        Object.entries(langStringParams).forEach(([paramKey, paramValue]) => {
                            const isUrlParam =
                                paramKey === ':url' ||
                                paramKey.endsWith('_url');

                            if (!isUrlParam) {
                                return;
                            }

                            if (typeof paramValue !== 'string') {
                                return;
                            }

                            if (!paramValue.startsWith('/')) {
                                return;
                            }

                            if (paramValue.startsWith('/' + locale + '/')) {
                                return;
                            }

                            langStringParams[paramKey] = '/' + locale + paramValue;
                        });
                    }

                    for (const [k, v] of Object.entries(langStringParams)) {
                        langString = langString.replaceAll(k, v);
                    }
                }
            }

            return langString;
        }
    }
}
